<script lang="ts">
    import { browser } from '$app/environment';
    import { page } from '$app/stores';

    import { onMount } from 'svelte';

    onMount(() => {
        if (browser) {
            console.warn(`Page Error: ${$page.status} - ${$page.error.message}`, {
                data: {
                    error: $page.error,
                    status: $page.status,
                    responseText: $page.error.message,
                    campaignId: $page.data?.campaignId,
                    companyId: $page.data?.companyId,
                    ...$page.params,
                },
            });
        }
    });
</script>

<div class="fun-flex fun-h-96 fun-w-full fun-items-center fun-justify-center">
    <div class="fun-p-6">
        <div class="fun-rounded-2xl fun-border fun-bg-white fun-p-6 fun-shadow-xl">
            <div class="fun-flex-shrink-0 fun-text-3xl fun-text-amber-500">⚠️</div>
            <div class="fun-mt-3">
                <h1 class="fun-font-bold">{$page.status} {$page.error.message}</h1>
                <span class="fun-text-sm fun-text-gray-400">
                    {$page.data?.cookieOverlay?.language === 'de'
                        ? 'Versuche deinen Browser Cache zu leeren und die Seite erneut zu laden.'
                        : 'Try clearing your browser cache and reload the page.'}
                </span>
            </div>
        </div>
    </div>
</div>
